var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showGPay)?_c('v-btn',{class:{
      'gpay-button': true,
      white: !_vm.isDark,
      black: _vm.isDark,
      short: true,
    },attrs:{"outlined":"","aria-label":"Google Pay"},on:{"click":_vm.onGooglePaymentsButtonClicked}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }